import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'

import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import {
  SeasonChipsLabelSC,
  SeasonChipsRowSC,
  SeasonChipsTrackSC,
} from './SeasonBlock.styled'

export interface ISeasonChipsRowProps {
  /** Locale word taken from `season_number` with an empty number, e.g. "Season". */
  title?: ITextBoxProps['title']
  children?: React.ReactNode
  dataTestId?: string
}

/**
 * The season selector of the series details page: a "Season" label and one
 * numbered chip per season, scrolled horizontally once the row runs out of
 * width (Figma `16273:212314`).
 */
export const SeasonChipsRow = ({
  title,
  children,
  dataTestId,
}: ISeasonChipsRowProps): JSX.Element => (
  <SeasonChipsRowSC data-testid={dataTestId}>
    {title ? (
      <SeasonChipsLabelSC>
        <TextBox
          title={title}
          font={TextBoxTypes.FontSmBold}
          color={TextBoxColors.TEXT_ICON_PRIMARY}
          maxLines={1}
        />
      </SeasonChipsLabelSC>
    ) : null}
    <SeasonChipsTrackSC>{children}</SeasonChipsTrackSC>
  </SeasonChipsRowSC>
)

SeasonChipsRow.displayName = 'SeasonChipsRow'
